import styled from 'styled-components';

import { TSvgTypes } from '@r1-frontend/ui-react/components/svg/TSvgTypes';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

type TReturnType = {
    contour: string | null,
    guts: string | null,
    mainBg: COLORS | 'transparent',
};

const getColorSchemeByType = (type: TSvgTypes): TReturnType => {
    switch (type) {
        case 'info': {
            return {
                mainBg: 'transparent',
                contour: COLORS.Control,
                guts: COLORS.Control,
            };
        }
        case 'success': {
            return {
                mainBg: COLORS.Success,
                contour: null,
                guts: COLORS.TextWhite,
            };
        }
        case 'error': {
            return {
                mainBg: COLORS.Error,
                contour: null,
                guts: COLORS.TextWhite,
            };
        }
        case 'white': {
            return {
                mainBg: 'transparent',
                contour: COLORS.TextWhite,
                guts: COLORS.TextWhite,
            };
        }
        case 'gray': {
            return {
                mainBg: 'transparent',
                contour: COLORS.GRAY_DARK,
                guts: COLORS.GRAY_DARK,
            };
        }
        case 'whiteInversed': {
            return {
                mainBg: COLORS.TextWhite,
                contour: COLORS.Control,
                guts: COLORS.Control,
            };
        }
        case 'blackInversed': {
            return {
                mainBg: COLORS.Control,
                contour: COLORS.TextWhite,
                guts: COLORS.TextWhite,
            };
        }
        case 'warning': {
            return {
                mainBg: COLORS.LabelsText_3,
                contour: null,
                guts: COLORS.LabelsText_3,
            };
        }
        case 'attention': {
            return {
                mainBg: 'transparent',
                contour: COLORS.LabelsText_2,
                guts: COLORS.LabelsText_2,
            };
        }
        case 'blue': {
            return {
                mainBg: COLORS.Outline_Dark,
                contour: null,
                guts: COLORS.TextWhite,
            };
        }
        default: {
            return {
                mainBg: 'transparent',
                contour: null,
                guts: COLORS.Control,
            };
        }
    }
};

export const Svg = styled.svg<{ type: TSvgTypes }>`
    ${({ type }) => {
        const schema = getColorSchemeByType(type);
        let result = `fill: ${schema.mainBg};`;

        if (schema.contour !== '') {
            result = `${result}
            #contour { stroke: ${schema.contour}; }`;
        }

        if (schema.guts !== '') {
            result = `${result}
            #guts { stroke: ${schema.guts}; }`;
        }

        return result;
    }}
`;
